module.exports = __webpack_public_path__ + "static/media/marker-add.d945de30.svg";